import AccountWebSocketSubscriber from './account.websocket.subscriber'
import UserOnlineWebSocketSubscriber from './user-online.websocket.subscriber'
import AnswerWebsocketSubscriber from './answer.websocket.subscriber'
import AnswerGroupWebsocketSubscriber from './answerGroup.websocket.subscriber'
import SlideWebsocketSubscriber from './slide.websocket.subscriber'
import PresentationWebsocketSubscriber from './presentation.websocket.subscriber'
import SlideOptionWebsocketSubscriber from './slide-option.websocket.subscriber'
import OpentokWebsocketSubscriber from './opentok.websocket.subscriber'
import QuizWebsocketSubscriber from './quiz.websocket.subscriber'
import SlideAnnotationsWebsocketSubscriber from './slide-annotations.websocket.subscriber'

export const messageSubscribers = {
  ...AccountWebSocketSubscriber,
  ...UserOnlineWebSocketSubscriber,
  ...AnswerWebsocketSubscriber,
  ...SlideWebsocketSubscriber,
  ...PresentationWebsocketSubscriber,
  ...OpentokWebsocketSubscriber,
  ...QuizWebsocketSubscriber,
  ...SlideOptionWebsocketSubscriber,
  ...AnswerGroupWebsocketSubscriber,
  ...SlideAnnotationsWebsocketSubscriber,
}

export const getMessageSubscriber = (type) => {
  return messageSubscribers[type]
}
